module.exports = __webpack_public_path__ + "img/dang2.924a7205.png";